const MAX_LENGTH = 24;
function truncateMessage(message) {
  if (message.length <= MAX_LENGTH) {
    return message;
  }
  return `${message.slice(0, MAX_LENGTH)}\u2026`;
}
export {
  truncateMessage
};
//# sourceMappingURL=truncateMessage.mjs.map